import React, { useEffect, useContext, useRef, useState } from "react";
import WebServiceContext from "../WebService/ServiceContext";
import { BasicContext } from "../context/BasicContext";


import LawChart, { resizeChart } from "../js/LawChart"
import { Close } from "./SVG";


type ChartAProps = {
    hasDetail?: boolean,
    setOpen?: boolean,
    setClose?: () => void,
}

export default (props: ChartAProps) => {

    const ws = useContext(WebServiceContext)
    const bc = useContext(BasicContext)

    const chart = useRef<HTMLDivElement>(null)
    const [open, setMyOpen] = useState<boolean>()

    const [stateData, setStateData] = useState<LowStateInfo[]>()


    useEffect(() => {
        setMyOpen(props.setOpen)
        setTimeout(() => {
            resizeChart()
        }, 100);

    }, [props.setOpen])

    const closePanel = () => {
        if (props.setClose) {
            props.setClose()
        }
    }

    useEffect(() => {
        ws.WebService.asyncGetLowStateInfo().then(res => {
            //console.log(res as LowStateInfo[])
            setStateData(res as LowStateInfo[])
        })
        return
    }, [])

    useEffect(() => {
        if (chart) {
            //HibLawStateNew(chart)
            ws.WebService.asyncGetLowStateDashboard().then((res) => {
                let d: ResDatas = res as ResDatas
                LawChart("", chart.current, d)
            })
        }
        return
    }, [chart])


    if (props.hasDetail) {
        return (
            <div className={"hibModal  " + (open ? " open" : "")}>
                <div className="modalContent">
                    <div className="modalHeader">
                        <button className="close" onClick={closePanel}>
                            <Close/>
                        </button>
                        <h5 className="title">法令遵循課程狀態</h5>
                    </div>

                    <div className="modalBody">
                        <div className="chatA">
                            <p>
                                產壽險公會的法遵課程為分別認列，且需各自一年內完訓，課程完課時間落在產壽交叉區間，認證可同時認列。
                                請參考下圖粉紅色交叉區域(示意圖), 正確日期請參考建議上課區間<br />
                                業務員僅有壽險或產險證照，於一年內完訓即可。
                            </p>
                            <ul>
                                <li>註1: 未完訓者將依保險業務員管理規則第13條第1項辦理撤銷。</li>
                                <li>註2: 有法遵課程疑問請洽總公司。</li>
                                <li>註3: 完訓課程數以公會為準，本頁顯示課程數為收到公會回覆之現況。</li>
                            </ul>
                            <div ref={chart} style={{ width: "100%", height: 300, backgroundColor: "#fff", marginTop: 15 }}></div>
                            <div className="table-box">
                                <table className="border">
                                    <tbody>
                                        <tr>
                                            <th>課程名稱</th>
                                            <th>完訓時間</th>
                                            <th>適用壽險年期</th>
                                            <th>適用產險年期</th>
                                            <th> </th>
                                        </tr>
                                        {
                                            stateData?.map((item: LowStateInfo, index: number) => {
                                                return (
                                                    <tr key={"tr_" + index}>
                                                        <td>{item.CosName}</td>
                                                        <td>{item.CompleteDate}</td>
                                                        <td>{item.LYear ? item.LYear : "無"}</td>
                                                        <td>{item.RYear ? item.RYear : "無"}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div ref={chart} style={{ width: "100%", height: 300, backgroundColor: "#fff", marginTop: 15 }}></div>
        )

    }


}
